import { useMutation } from '@tanstack/react-query';
import requestGetDestinationAffinityCopy from '~/queries/customerCommunication/requestGetDestinationAffinityCopy';
import requestGetDestinationAffinityDraft from '~/queries/customerCommunication/requestGetDestinationAffinityDraft';

// Both are GETs, but they're mutations on purpose: they run on a button click and every click should generate afresh
// rather than hand back a cached result.

/**
 * Builds a destination affinity draft: the hero image, offers ranked by margin and trending destinations.
 */
export function useGenerateDestinationAffinityDraft() {
  return useMutation({ mutationFn: requestGetDestinationAffinityDraft });
}

/**
 * Writes a destination affinity email's subject lines and intro, and picks its articles, from the given offers.
 */
export function useGenerateDestinationAffinityCopy() {
  return useMutation({ mutationFn: requestGetDestinationAffinityCopy });
}
